export class TicketNameHelper {
  public static removeTravellerCategory(name: string): string {
    return name.replace(' Ungdom', '').replace(' Vuxen', '').replace(' ungdom', '').replace(' vuxen', '');
  }
}
